import React, { useContext } from 'react';
import { UserContext } from '../users/UserContext';
import { Permission, userHasPermission } from './permission';

type Props = {
  requiredPermission: Permission;
  children: React.ReactNode;
};

export const IfUserHasPermission = (props: Props) => {
  const user = useContext(UserContext).getUser();
  return userHasPermission({ user, permission: props.requiredPermission }) ? <>{props.children}</> : null;
};
